export default __webpack_public_path__ + "static/media/bb.1cc03970.svg";